import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import CBAErrorHandler from '../error/error.handler';

export class AuthComponent{
  protected loggedInUser: any;

  constructor(
    protected router: Router,
    protected loginService: LoginService
  ){}
  
  init(){
    return this.loginService.isLoggedIn().then((result)=>{
      this.loggedInUser = result;
    }).catch((e)=>{
      this.router.navigateByUrl('/error/not-authorised');
    });
  }

  handleError(e){
    console.error(e);
    if (e._body) {
      try {
        let serverResponse = JSON.parse(e._body);
        e.statusText = serverResponse['message'];
      } catch(e) {}
    }

    if (e.status === 403) {
      this.router.navigateByUrl('/error/not-authorised');
    } else if (e.status === 404) {
      this.router.navigateByUrl('/error/not-found');
    }else {
      let errorHandler = new CBAErrorHandler();
      errorHandler.notifyRaven(e);
      this.router.navigateByUrl('/error/internal-error');
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/login/auth.component.ts